export default "__VITE_ASSET__BUlXN5aq__"